import React, { useContext, useMemo } from "react";
import { TagDinamicaContext } from "../../contexts/TagDinamicaContext";
import { useForm } from "react-hook-form";
import formatDommus from "../../helpers/format";
import { Button, Form } from "react-bootstrap";
import moment from "moment";
import "./index.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";

export function FormAtribuirTagsDinamicas({mensagemInicialFormatar, enviarMensagemTemplate, closeModal}){
  const methods = useForm();
  const {tagDinamicaLista, mapTagDinamicaLista} = useContext(TagDinamicaContext)
  
  const tagsUtilizadas = useMemo(()=>{
    if(mensagemInicialFormatar?.mensagem){
      return tagDinamicaLista.filter((item) => {
        return mensagemInicialFormatar?.mensagem.includes(`[[${item?.tag}]]`)
      })
    }else{
      return [];
    }
  },[mensagemInicialFormatar, tagDinamicaLista])

  const handleResolverCampo = (item)=>{
    switch(item?.tipo){
      case 'ST':
        return(
          <Form.Group>
            <Form.Label>{item?.descricao}</Form.Label>
            <Form.Control
              type="text"
              {...methods.register(item?.tag, { required: false })}
            >
            </Form.Control>
          </Form.Group>
        )
      case 'DT':
        return(
          <Form.Group>
            <Form.Label>{item?.descricao}</Form.Label>
            <Form.Control
              type="date"
              {...methods.register(item?.tag, { required: false })}
            >
            </Form.Control>
          </Form.Group>
        )
      case 'VA':
        return(
          <Form.Group>
            <Form.Label>{item?.descricao}</Form.Label>
            <Form.Control
              type="text"
              {...methods.register(item?.tag, { required: false })}
              onChange={(event)=>{
                methods.setValue(item?.tag, formatDommus.realMoeda(event.target.value));
              }}
            >
            </Form.Control>
          </Form.Group>
        )
      default:
        return <></>
    }
  }

  const handleOnSubmit = (data)=>{
    let mensagem = mensagemInicialFormatar.mensagem;
    for(const key of Object.keys(data)){
      let valor = data[key];
      switch(mapTagDinamicaLista[key]?.tipo){
        case 'DT':
          valor = moment(valor).format("DD/MM/YYYY");
          data[key] = valor;
          break;
        default:
          break;
      }
      let regex = new RegExp(`\\[\\[${key}\\]\\]`, "g");
      mensagem = mensagem.replace(regex, valor);
    }

    mensagemInicialFormatar.mensagem = mensagem;
    mensagemInicialFormatar.tags = data

    enviarMensagemTemplate(mensagemInicialFormatar);
    closeModal();
  }

  return (
    <Form className="componentes-section" onSubmit={methods.handleSubmit(handleOnSubmit)}>
      {!!tagsUtilizadas?.length ? tagsUtilizadas?.map((item, index)=>{
        return(
          <div key={index}>
            {handleResolverCampo(item)}
          </div>
        )
      }) : <></>}
      <div className="footer">
        <Button type="submit" variant="success">Enviar <FontAwesomeIcon icon={faPaperPlane}/></Button>
      </div>
    </Form>
  )
}
